<template>
    <footer class="pt-5 pb-5">
        <div class="custom-container">
            <div class="row d-flex">
                <div class="col-xl-4 col-12">
                    <div class="partners bg-secondary p-4 rounded d-flex justify-content-between align-items-center">
                        <a href="https://www.staz.nl" target="_blank"><img src="/img/partners/staz.svg"></a>
                        <a href="https://www.arbeidsmarktgehandicaptenzorg.nl" target="_blank"><img src="/img/partners/stag.svg"></a>
                        <a href="https://sofokles.nl" target="_blank"><img src="/img/partners/sofokles.svg"></a>
                    </div>
                </div>
                <div class="col-xl-8 col-12 ms-auto text-end align-self-end">
                    <router-link to="/copyright" class="me-5">Copyright &copy; {{ currentYear }} RisicoRadar</router-link>
                    <router-link to="/disclaimer" class="me-5">Disclaimer</router-link>
                    <router-link to="/privacyverklaring" class="me-0">Privacyverklaring</router-link>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
            currentYear: new Date().getFullYear()
        }
    }
}
</script>
